import { spcColors } from '@finam/web-ui-kit';
export default Object.assign(Object.assign({}, spcColors), {
  accent: {
    1: '#6CA2FF',
    2: '#6CA2FF'
  }
});